import PropTypes from 'prop-types';

const ArticleDetails = ({children}) => (
  <div className="article-details">
    {children}
  </div>
);

ArticleDetails.propTypes = {
  children: PropTypes.node
};

export default ArticleDetails;
